import { render, staticRenderFns } from "./RequiredProduct.vue?vue&type=template&id=0fea379e&scoped=true&"
import script from "./RequiredProduct.vue?vue&type=script&lang=js&"
export * from "./RequiredProduct.vue?vue&type=script&lang=js&"
import style0 from "./RequiredProduct.vue?vue&type=style&index=0&id=0fea379e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fea379e",
  null
  
)

export default component.exports